// Support: quick answers + the way to a person. ORCA support runs in the
// Telegram support bot (operators, tickets, ratings — CLAUDE.md §36), so the
// site does not pretend to take a message itself: it opens the bot.
import { useState } from 'react';
import { Link } from 'react-router';
import { Icon } from '@/components/ui/Icon';
import { useSheet } from '@/components/ui/Sheet';
import { cx } from '@/lib/format';
import i18n, { useT } from '@/i18n';

const SUPPORT_BOT = 'https://t.me/sssssupport_bot';
/** FAQ texts: profile:support.faq.<id>.{q,a}; two answers carry a link into the site */
const FAQ_IDS = ['plans', 'trial', 'pay', 'ends', 'change', 'interval', 'coins', 'notices'] as const;
const FAQ_LINK: Partial<Record<(typeof FAQ_IDS)[number], string>> = { coins: '/settings', notices: '/alerts#channels' };

export function useOpenSupport() {
  const { openSheet } = useSheet();
  return () => openSheet({ kicker: 'Orca', title: i18n.t('profile:support.title'), body: <SupportPanel />, className: 'sup-sheet' });
}

export function SupportPanel({ inline = false }: { inline?: boolean }) {
  const { t } = useT('profile');
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div className={cx('sup', inline && 'inline')}>
      <div className="sup-faq">
        <span className="k">{t('support.faqTitle')}</span>
        {FAQ_IDS.map((id, i) => (
          <div key={id} className={cx('sup-q', open === i && 'open')}>
            <button type="button" aria-expanded={open === i} onClick={() => setOpen(open === i ? null : i)}><span>{t(`support.faq.${id}.q`)}</span><Icon name="chev" /></button>
            {open === i && <p>{FAQ_LINK[id] ? <>{t(`support.faq.${id}.a1`)}<Link to={FAQ_LINK[id]!}>{t(`support.faq.${id}.link`)}</Link>{t(`support.faq.${id}.a2`)}</> : t(`support.faq.${id}.a`)}</p>}
          </div>
        ))}
      </div>
      <div className="sup-tg">
        <span className="k">{t('support.write')}</span>
        <p>{t('support.tgText')}</p>
        <a className="sup-tg-go" href={SUPPORT_BOT} target="_blank" rel="noreferrer">
          <span className="sup-tg-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m20.8 4.1-3 15c-.2 1.1-.8 1.4-1.7.9l-4.6-3.4-2.2 2.1c-.2.3-.5.5-.9.5l.3-4.7 8.5-7.7c.4-.3-.1-.5-.6-.2L6.1 13.2l-4.5-1.4c-1-.3-1-1 .2-1.5l17.6-6.8c.8-.3 1.6.2 1.4.6Z" /></svg></span>
          <span className="sup-tg-t"><b>{t('support.openBot')}</b><small>{t('support.handle')}</small></span>
          <span className="sup-tg-arr" aria-hidden="true">↗</span>
        </a>
        <small className="sup-tg-note">{t('support.tgNote')}</small>
      </div>
    </div>
  );
}
